import { EntitySelectorsFactory } from '@ngrx/data';

import { TipoSexoBiologico } from './entity-sexo-biologico.model';

export const tipoSexoBiologicoSelectors =
  new EntitySelectorsFactory().create<TipoSexoBiologico>('TipoSexoBiologico');

export const selectAllTiposSexoBiologico =
  tipoSexoBiologicoSelectors.selectEntities;
